import {
  selectSchema,
  selectUI,
  textSchema,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import VhaFacilityAutosuggestField from '../components/VhaFacilityAutosuggestField';
import { FORM_10_8678 } from '../definitions/constants';
import {
  getVhaMedicalFacilityLabel,
  isOtherVhaMedicalFacility,
} from '../definitions/facilities';
import {
  getDefaultVhaFacilityState,
  isVhaFacilityStateCode,
  VHA_FACILITY_STATE_LABELS,
  VHA_FACILITY_STATE_VALUES,
} from '../definitions/facilityStates';
import { getVhaMedicalFacilityOptions } from '../services/facilities';

const { VHA_MEDICAL_FACILITY } = FORM_10_8678;

export const updateVhaFacilityStateSchema = (
  fieldData,
  schema,
  _uiSchema,
  _index,
  _path,
  fullData = {},
) => {
  if (isVhaFacilityStateCode(fieldData)) {
    return schema;
  }

  const defaultState = getDefaultVhaFacilityState(fullData?.address);
  return defaultState
    ? {
        ...schema,
        default: defaultState,
      }
    : schema;
};

export default {
  uiSchema: {
    ...titleUI(VHA_MEDICAL_FACILITY.TITLE, VHA_MEDICAL_FACILITY.DESCRIPTION),

    vhaMedicalFacilityState: selectUI({
      title: VHA_MEDICAL_FACILITY.STATE_FIELD_LABEL,
      hint: VHA_MEDICAL_FACILITY.STATE_FIELD_HINT,
      labels: VHA_FACILITY_STATE_LABELS,
      required: () => true,
      errorMessages: {
        required: VHA_MEDICAL_FACILITY.STATE_FIELD_ERROR,
      },
      updateSchema: updateVhaFacilityStateSchema,
    }),

    vhaMedicalFacility: {
      'ui:title': VHA_MEDICAL_FACILITY.FIELD_LABEL,
      'ui:field': VhaFacilityAutosuggestField,
      'ui:required': () => true,
      'ui:errorMessages': {
        required: VHA_MEDICAL_FACILITY.FIELD_ERROR,
      },
      'ui:options': {
        ariaLabel: VHA_MEDICAL_FACILITY.FIELD_LABEL,
        hint: VHA_MEDICAL_FACILITY.FIELD_HINT,
        classNames: 'vads-u-margin-top--1p5',
        placeholder: 'Select a facility',
        maxOptions: 150,
        getOptions: getVhaMedicalFacilityOptions,
        statePath: 'vhaMedicalFacilityState',
      },
      'ui:confirmationField': ({ formData }) => ({
        label: VHA_MEDICAL_FACILITY.FIELD_LABEL,
        data: getVhaMedicalFacilityLabel(formData),
      }),
    },

    vhaMedicalFacilityOther: {
      ...textUI(VHA_MEDICAL_FACILITY.OTHER_LABEL),
      'ui:options': {
        hideIf: formData =>
          !isOtherVhaMedicalFacility(formData?.vhaMedicalFacility),
      },
      'ui:required': formData =>
        isOtherVhaMedicalFacility(formData?.vhaMedicalFacility),
      'ui:errorMessages': {
        required: VHA_MEDICAL_FACILITY.OTHER_ERROR,
      },
    },
  },

  schema: {
    type: 'object',
    required: ['vhaMedicalFacilityState', 'vhaMedicalFacility'],
    properties: {
      vhaMedicalFacilityState: selectSchema(VHA_FACILITY_STATE_VALUES),
      vhaMedicalFacility: { type: 'string' },
      vhaMedicalFacilityOther: textSchema,
    },
  },
};
